import styled from 'styled-components';
import BREAKPOINTS from 'styles/breakpoints';
import COLORS from 'styles/colors';
import RichText from 'components/RichText';
import { H6 } from 'styles/typography';

const TermsContainer = styled.div`
  max-width: 1160px;
  margin: 0 var(--gutter-side);
  padding-top: 40px;
  padding-bottom: 60px;
  border-top: 1px solid ${COLORS.forest};

  ${BREAKPOINTS.medium`
	  padding-bottom: 150px;
	`};

  ${BREAKPOINTS.large`
		margin: auto;
	`}
`;

const HeadingWrapper = styled.div`
  color: ${COLORS.forest};
`;

const Copy = styled(RichText)``;

const WhatsOnTerms = ({ heading, description }) => {
  return (
    <TermsContainer>
      {heading && (
        <HeadingWrapper>
          <H6>{heading}</H6>
        </HeadingWrapper>
      )}

      <Copy html={description?.html} />
    </TermsContainer>
  );
};

export default WhatsOnTerms;
